export function getMean(array) {
  const n = array.length;
  if (n == 0) {
    return (0).toFixed(2);
  }
  return (array.reduce((a, b) => a + b) / n).toFixed(2);
}

export function getStandardDeviation(array) {
  const n = array.length;
  if (n < 10) {
    return null;
  }
  const mean = getMean(array);
  return Math.sqrt(
    array.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n
  ).toFixed(2);
}

export function get3Point(value) {
  try {
    return value.toFixed(3);
  }
  catch {
    return "NA";
  }
}

export function getPval(pval) {
  try {
    if (pval < 0.001) {
      return pval.toExponential(2);
    } else {
      return pval.toFixed(3);
    }
  }
  catch {
    return "NA"
  }

}